import EmailIcon from '@mui/icons-material/Email';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Box, Button, Paper, Typography } from '@mui/material';
import type React from 'react';
import type { DisplayUser } from './types';

interface UserSecurityActionsProps {
  user: DisplayUser;
  canEditUser: boolean;
  onResetPassword: () => void;
  onResendInvite: () => void;
}

export const UserSecurityActions: React.FC<UserSecurityActionsProps> = ({
  user,
  canEditUser,
  onResetPassword,
  onResendInvite,
}) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Security Actions
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {canEditUser && user.status !== 'pending' && (
          <Button variant="outlined" startIcon={<VpnKeyIcon />} onClick={onResetPassword}>
            Reset Password
          </Button>
        )}
        {user.status === 'pending' && canEditUser && (
          <Button variant="outlined" startIcon={<EmailIcon />} onClick={onResendInvite}>
            Resend Invite
          </Button>
        )}
      </Box>
    </Paper>
  );
};
